module.exports = __webpack_public_path__ + "img/Austin.5a5e6168.png";